
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.68 9.15l1.701 1.676c.459.438.88.914 1.243 1.447.478.667.86 1.39 1.013 2.095.248.704.363 1.447.363 2.228 0 2.037-.88 3.866-2.294 5.122-.535.476-.535 1.238 0 1.733.516.457.956 1.085 1.32 1.695.076.133.171.285.228.438.478.933.746 1.98.746 3.104 0 .666-.096 1.295-.268 1.904a6.576 6.576 0 01-.783 1.904c-.65 1.086-1.549 1.923-2.676 2.552a7.444 7.444 0 01-3.69.952H13.63a3.166 3.166 0 01-2.198-.895L.918 24.651A3.047 3.047 0 010 22.46V1.572C0 .715.688.029 1.548.029h11.565c.86 0 1.548.686 1.548 1.543v16.7a2.587 2.587 0 01-2.657 2.59c-1.414-.02-2.561-1.276-2.561-2.686v.058c0-.096 0-.19-.02-.286v-.724c0-.761-.61-1.37-1.375-1.37H5.696c-.764 0-1.376.609-1.376 1.37v1.238l.02.933s.152 2.761 1.949 4.418c1.242 1.143 3.192 2.285 5.333 2.38h.67c2.006 0 3.67-.61 4.988-1.637h.02c.42-.305.783-.667 1.108-1.067a5.772 5.772 0 001.07-2c.689-2.037.593-4.912.593-4.912V1c0-.895 1.07-1.333 1.701-.704L30.68 9.15z","fill":"#5072FF"}})])
          )
        }
      }
    